<template>
  <v-dialog v-model="dialogchangepassword" persistent max-width="600px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-card>
      <v-card-title>
        <h2 class="primary--text mb-4">{{ $t("changePasswordQuestion") }}?</h2>
      </v-card-title>
      <v-card-text class="pb-0 mb-0">
        <v-form>
          <v-row>
            <v-text-field
              :label="$t('insertPassword')"
              v-model="newPassword1"
              ref="firstPassField"
              autocomplete="off"
              @keydown.enter="checkNewPassword"
              :rules="[newPassword1 != newPassword2 ? $t('passwordNoMatch') + '!' : true, newPassword1.length < 5 ? $t('passwordTooShort') + '!' : true]"
              type="password"
              required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              :label="$t('confirmPassword')"
              v-model="newPassword2"
              @keydown.enter="checkNewPassword"
              autocomplete="off"
              type="password"
              :rules="[newPassword1 != newPassword2 ? $t('passwordNoMatch') + '!' : true]"
              required
            ></v-text-field>
          </v-row>
        </v-form>
        <v-layout class="mb-0" justify-end row>
          <v-flex xs6 class="pa-0 ma-0" v-if="newpasswordonlogin">
            <v-checkbox class="pa-0 ma-0" v-model="changePassOnLogin" :label="$t('resetPassOnLogin')"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" @click="clearFields">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="green white--text darken-1"
          :disabled="newPassword1 != newPassword2 || newPassword1 == '' || newPassword1.length < 5"
          @click="checkNewPassword()"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
module.exports = {
  data: () => ({
    newPassword1: "",
    newPassword2: "",
    dialogchangepassword: true,
    changePassOnLogin: true,
    apiRoot: localStorage.getItem("apiRoot"),
    loaderOverlay: false
  }),
  props: {
    empid: String,
    newpasswordonlogin: Boolean
  },
  created: function () {
    if (!this.newpasswordonlogin) this.changePassOnLogin = false;
    setTimeout(() => {
      this.$refs.firstPassField.focus();
    });
  },
  methods: {
    checkNewPassword() {
      const passwordNotEmpty = !!this.newPassword1;
      const passwordsMatch = this.newPassword1 == this.newPassword2;
      const passwordLongEnough = this.newPassword1.length > 4;

      if (passwordNotEmpty && passwordsMatch && passwordLongEnough) this.sendChangedPassword(this.empid, this.newPassword1);
    },
    clearFields() {
      this.newPassword1 = "";
      this.newPassword2 = "";
      this.dialogchangepassword = true;
      this.$emit("finished");
    },
    sendChangedPassword(idValue, newPassword) {
      let postUser = {
        loginUser: idValue,
        password: newPassword,
        changeOnLogin: this.changePassOnLogin
      };
      this.loaderOverlay = true;
      this.$http({
        url: this.apiUrl + "/api/users/changePassword",
        data: postUser,
        method: "PATCH"
      })
        .then(() => {
          this.$eventHub.$emit("showSuccess", this.$t("passwordSaved") + "!");
          this.clearFields();
        })
        .catch((err) => {
          console.log(err);
          this.$eventHub.$emit("showError", err.response.data);
          this.clearFields();
        });

      this.loaderOverlay = false;
    }
  }
};
//@ sourceURL=resetPassword.js
</script>

<style></style>
